"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventRegistry_1 = __importDefault(require("./EventRegistry"));
var InMemoryCollection_1 = __importDefault(require("./InMemoryCollection"));
var maxSize = 100;
var ChannelsStorage = /** @class */ (function () {
    function ChannelsStorage() {
        this.loadingEarlier = false;
        this.hasMoreEarlier = false;
        this.channelsCollection = new InMemoryCollection_1.default('id');
        this.eventRegistry = new EventRegistry_1.default();
        this.liveUpdate = true;
        this.loadingLater = false;
        this.initialDataLoaded = false;
        this.maxRetryAttemptsReached = false;
        this.newUnreadMessages = new Set();
        this.blackList = [];
        this.archivedChannels = [];
    }
    ChannelsStorage.prototype.upsert = function (channels) {
        var len = channels.length;
        for (var i = 0; i < len; i++) {
            if (channels[i].lastMessage) {
                // only upsert unempty channels
                this.channelsCollection.upsert(channels[i]);
            }
        }
    };
    ChannelsStorage.prototype.update = function (channel) {
        this.upsert([channel]);
        this.eventRegistry.emit('update', { channel: channel });
    };
    ChannelsStorage.prototype.remove = function (channelId) {
        this.channelsCollection.remove(channelId);
        this.eventRegistry.emit('delete', { channelId: channelId });
    };
    ChannelsStorage.prototype.addLaterChannels = function (laterChannels) {
        this.upsert(laterChannels);
        if (maxSize && laterChannels.length < maxSize) {
            this.liveUpdate = true;
        }
        else {
            this.liveUpdate = false;
        }
    };
    ChannelsStorage.prototype.sortedChannels = function () {
        var _this = this;
        return this.channelsCollection
            .sort('lastActivityAt', 'desc')
            .map(function (channel) { return (__assign(__assign({}, channel), { isArchived: _this.archivedChannels.some(function (ac) { return ac.channelId === channel.id; }) })); });
    };
    ChannelsStorage.prototype.earliestDate = function () {
        var _a;
        var channels = this.channelsCollection.sort('lastActivityAt', 'asc');
        return (_a = channels[0]) === null || _a === void 0 ? void 0 : _a.lastActivityAt;
    };
    ChannelsStorage.prototype.latestDate = function () {
        var _a;
        var channels = this.channelsCollection.sort('updatedAt', 'desc');
        return (_a = channels[0]) === null || _a === void 0 ? void 0 : _a.updatedAt;
    };
    ChannelsStorage.prototype.loadEarlier = function (chatClient) {
        var _this = this;
        this.loadingEarlier = true;
        return new Promise(function (resolve) {
            chatClient
                .loadEarlierChannels(_this.earliestDate(), maxSize)
                .then(function (earlierChannels) {
                _this.loadingEarlier = false;
                _this.upsert(earlierChannels);
                if (maxSize && earlierChannels.length < maxSize) {
                    _this.hasMoreEarlier = false;
                }
                else {
                    _this.hasMoreEarlier = true;
                }
                // TODO setLastRecievedMessageId(channelX.channelId, channelX.lastMessage.id)
                _this.errorMessage = undefined;
                _this.initialDataLoaded = true;
                _this.eventRegistry.emit('update', {});
                resolve(earlierChannels);
            })
                .catch(function (error) {
                //Emit Error
                _this.loadingEarlier = false;
                _this.errorMessage = error.message;
                _this.eventRegistry.emit('update', {});
                resolve([]);
            });
        });
    };
    ChannelsStorage.prototype.loadLater = function (chatClient) {
        return __awaiter(this, void 0, void 0, function () {
            var laterChannels, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingLater = true;
                        this.eventRegistry.emit('update', {});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, chatClient.loadLaterChannels(this.latestDate(), maxSize)];
                    case 2:
                        laterChannels = _a.sent();
                        // TODO setLastRecievedMessageId(channelX.channelId, channelX.lastMessage.id)
                        this.loadingLater = false;
                        this.addLaterChannels(laterChannels);
                        this.eventRegistry.emit('update', {});
                        return [2 /*return*/, laterChannels];
                    case 3:
                        error_1 = _a.sent();
                        this.loadingLater = false;
                        this.eventRegistry.emit('update', {});
                        console.log(error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ChannelsStorage.prototype.loadAllLater = function (chatClient) {
        return __awaiter(this, void 0, void 0, function () {
            var allLaterChannels, channels, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.initialDataLoaded)
                            return [2 /*return*/, []];
                        this.liveUpdate = false;
                        allLaterChannels = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        _a.label = 2;
                    case 2:
                        if (!!this.liveUpdate) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadLater(chatClient)];
                    case 3:
                        channels = _a.sent();
                        allLaterChannels.push.apply(allLaterChannels, channels);
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, allLaterChannels];
                    case 5:
                        error_2 = _a.sent();
                        return [2 /*return*/, allLaterChannels];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ChannelsStorage.prototype.find = function (channelId) {
        var doc = this.channelsCollection.find(channelId);
        return doc;
    };
    ChannelsStorage.prototype.get = function (channelId, chatClient, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var doc, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        doc = this.channelsCollection.find(channelId);
                        if (doc)
                            return [2 /*return*/, doc];
                        return [4 /*yield*/, chatClient.getChannel(channelId, undefined, filter)];
                    case 1:
                        channels = _a.sent();
                        if (channels.length > 0) {
                            this.upsert(channels);
                            return [2 /*return*/, channels[0]];
                        }
                        throw new Error('Channel not found');
                }
            });
        });
    };
    ChannelsStorage.prototype.getByExternalId = function (channelExternalId, chatClient) {
        return __awaiter(this, void 0, void 0, function () {
            var doc, channels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        doc = this.channelsCollection.findBy({
                            externalId: channelExternalId,
                        });
                        if (doc)
                            return [2 /*return*/, doc];
                        return [4 /*yield*/, chatClient.getChannel(undefined, channelExternalId)];
                    case 1:
                        channels = _a.sent();
                        if (channels.length > 0) {
                            this.upsert(channels);
                            return [2 /*return*/, channels[0]];
                        }
                        throw new Error('Channel not found');
                }
            });
        });
    };
    ChannelsStorage.prototype.state = function () {
        return {
            liveUpdate: this.liveUpdate,
            channels: this.sortedChannels(),
            hasMoreEarlier: this.hasMoreEarlier,
            loadingEarlier: this.loadingEarlier,
            loadingLater: this.loadingLater,
            errorMessage: this.errorMessage,
            maxRetryAttemptsReached: this.maxRetryAttemptsReached,
            blackList: this.blackList,
        };
    };
    ChannelsStorage.prototype.onUpdate = function (callback) {
        return this.eventRegistry.on('update', callback);
    };
    ChannelsStorage.prototype.onDelete = function (callback) {
        return this.eventRegistry.on('delete', callback);
    };
    ChannelsStorage.prototype.setMaxRetryAttemptsReached = function (flag) {
        this.maxRetryAttemptsReached = flag;
        this.eventRegistry.emit('update', {});
    };
    ChannelsStorage.prototype.setBlackList = function (blackList) {
        this.blackList = blackList;
        this.eventRegistry.emit('update', {});
    };
    ChannelsStorage.prototype.setArchivedChannels = function (archivedChannels, targetChannelId) {
        this.archivedChannels = archivedChannels;
        var channels = this.sortedChannels();
        this.upsert(channels);
        this.eventRegistry.emit('update', {
            channel: channels.find(function (c) { return c.id === targetChannelId; }),
        });
    };
    return ChannelsStorage;
}());
exports.default = ChannelsStorage;
//# sourceMappingURL=ChannelStorage.js.map